import { bunja } from 'bunja';
import { atom } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import segment from '@flipster/utils/segment';
import { TpslEventPayload, TradeEvent } from '@flipster/utils/segment/events/trade';

import { tpslModalSegmentBunja } from '../segment';
import { tpslModalBunja } from '../state';
import { parentPositionBunja } from '../state/base';
import { tpslModalInputBunja, tpslModalInputDerivationBunja } from './state';

export const tpslFormSegmentBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { entryOrOrderPriceAtom } = bunja.use(parentPositionBunja);
  const { positionQtyAtom } = bunja.use(tpslModalBunja);
  const { triggerPriceInputValueAtom, partialQtyPercentAtom } = bunja.use(tpslModalInputBunja);
  const { priceDiffFromEntryPriceAtom, estimatedPnlAtom } = bunja.use(tpslModalInputDerivationBunja);
  const { commonEventPayloadAtom, tpslTabAtom } = bunja.use(tpslModalSegmentBunja);

  const tpslEventPayloadAtom = atom<TpslEventPayload>((get) => {
    const commonEventPayload = get(commonEventPayloadAtom);
    const positionQty = get(positionQtyAtom);
    const priceDiffFromEntryPrice = get(priceDiffFromEntryPriceAtom);
    const estimatedPnl = get(estimatedPnlAtom);
    const entryOrOrderPrice = get(entryOrOrderPriceAtom);
    const triggerPriceInputValue = get(triggerPriceInputValueAtom);
    const partialQtyPercent = get(partialQtyPercentAtom);
    return {
      ...commonEventPayload,
      quantity: positionQty.toNumber(),
      from_entry_percentage: priceDiffFromEntryPrice.toNumber(),
      estimated_pnl: estimatedPnl.toNumber(),
      entry_price: entryOrOrderPrice.toNumber(),
      trigger_price: triggerPriceInputValue.toNumber(),
      partial_ratio: partialQtyPercent / 100,
    };
  });

  function trackTpslSettingView() {
    const tab = store.get(tpslTabAtom);
    segment.track(TradeEvent.TpslSettingView, {
      ...store.get(tpslEventPayloadAtom),
      tab: tab === 'entire' ? 'Entire' : 'Partial',
    });
  }
  function trackTpslCurrentPriceClick() {
    segment.track(TradeEvent.TpslCurrentPriceClick, store.get(tpslEventPayloadAtom));
  }
  function trackTpslPriceClearClick() {
    segment.track(TradeEvent.TpSlPriceClearClick, store.get(tpslEventPayloadAtom));
  }
  function trackTpslPriceEditClick() {
    segment.track(TradeEvent.TpSlPriceEditClick, store.get(tpslEventPayloadAtom));
  }
  function trackTpslPriceResetClick() {
    segment.track(TradeEvent.TpSlPriceResetClick, store.get(tpslEventPayloadAtom));
  }
  function trackTpslSettingConfirmClick() {
    segment.track(TradeEvent.TpSlSettingConfirmClick, store.get(tpslEventPayloadAtom));
  }
  function trackTpslRatioSliderClick() {
    segment.track(TradeEvent.TpslRatioSliderClick, store.get(tpslEventPayloadAtom));
  }

  function trackTpslPreferenceBottomsheetView(title: string) {
    segment.track(TradeEvent.TpslPreferenceBottomsheetView, { title });
  }

  return {
    trackTpslSettingView,
    trackTpslCurrentPriceClick,
    trackTpslPriceClearClick,
    trackTpslPriceEditClick,
    trackTpslPriceResetClick,
    trackTpslSettingConfirmClick,
    trackTpslRatioSliderClick,
    trackTpslPreferenceBottomsheetView,
  };
});
tpslFormSegmentBunja.debugLabel = 'tpslFormSegmentBunja';
